/**
 * QuickStartButton Component
 * Button to open Quick Start Templates modal
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Sparkles } from 'lucide-react';

export const QuickStartButton = ({
  setShowQuickStart,
}) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setShowQuickStart(true)}
      className="p-2 text-zinc-400 hover:text-white hover:bg-emerald-500/20"
      data-testid="quick-start-btn"
      title="Quick Start Templates"
    >
      <Sparkles className="w-5 h-5" />
    </Button>
  );
};

export default QuickStartButton;
